/* eslint 'array-callback-return': 'off', eqeqeq: 'off'  */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Table, Button, Modal } from 'reactstrap';
import classnames from 'classnames';
import { closeModalPopUp } from '../../../../../action/modalStateAction';
import DeleteConfirmation from '../_ModalsForms/DeleteConfirmation';
import AddHolidayForm from '../_ModalsForms/Holidays/AddHolidayForm';
import EditHolidayForm from '../_ModalsForms/Holidays/EditHolidayForm';
import ErrorGif from '../../../../../Assets/images/Error.gif';
import { GetAllHolidays, DeleteHoliday, GetHolidayDetails} from '../../../../../action/HolidaysAction';
import SelectAllCheckboxes from '../../../../../Resources/SelectAllCheckboxes';
import SearchInput, { createFilter } from 'react-search-input';
import DatePicker from 'react-datepicker';
import DatePickerCustom from '../../../../common/DatePicker';
import Conversions from '../../../../../Resources/Conversions';


const KEYS_TO_FILTERS = ['holidayName', 'buildingNames', 'holidayDate'];


class Holidays extends Component {

  componentWillMount() {
    this.props.GetAllHolidays();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props != nextProps) {
      var modalClose = nextProps.ModalOpenCloseResponse.ModalOpenClose.modal_open;
      if (modalClose == "close") {
        this.setState({ modal: false, Editmodal: false, IsChangesSaved: true });
      }
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      holidayID: '',
      modal: false,
      Deletemodal: false,
      Editmodal: false,
      rows: '',
      filters: {},
      sortColumn: null,
      sortDirection: null,
      PastHolidays: false,
      error_msg: false,
      searchTerm: '',
      startDate: null,
      endDate: null,
      sort: {
        column: 'holidayName',
        direction: [
          {name:'holidayName', direction:'asc', onclick:true},
          {name:'buildingNames', direction:'desc', onclick:false},
          {name:'holidayDate', direction:'desc', onclick:false},
        ],
      },
      IsDefaultSort: true,
      IsChangesSaved: false,
    };
    this.toggle = this.toggle.bind(this);
    this.Deletetoggle = this.Deletetoggle.bind(this);
    this.DeleteHolidays = this.DeleteHolidays.bind(this);
    this.Edittoggle = this.Edittoggle.bind(this);
    this.LoadPastHolidays = this.LoadPastHolidays.bind(this);
    this.searchUpdated = this.searchUpdated.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
  }

  Edittoggle() {
    this.props.closeModalPopUp("open");
    this.setState({
      Editmodal: true
    });
  }

  toggle() {
    this.props.closeModalPopUp("open");
    this.setState({
      modal: true
    });
  }

  Deletetoggle() {
    this.setState({
      Deletemodal: !this.state.Deletemodal
    });
  }
  DeleteHolidays(){
      this.setState({error_msg:false});
      var IsAnyChecked = false;
      var checkboxes = document.getElementsByClassName('ZoneRows');
      for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked === true) {
          IsAnyChecked = true;
        }
      }
      if(IsAnyChecked) this.Deletetoggle();
      else this.setState({error_msg:true});
  }
  /* Delete Confirmation*/
  Delete = (someArg) => {
    if (someArg == "yes") {
      var Data = [];
      var checkboxes = document.getElementsByClassName('ZoneRows');
      for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked === true) {
          var Holiday_id_to_be_deleted = {
            "holidayId": checkboxes[i].id
          }
          Data.push(Holiday_id_to_be_deleted);
        }

      }
      if (Data.length > 0) {
        this.setState({ error_msg: false });
        this.props.DeleteHoliday(Data);
        this.Deletetoggle();
      }
      else {
        this.setState({ error_msg: true });
        this.Deletetoggle();
      }

    }
    else {
      this.Deletetoggle();
    }
  }
  /* Modal Pop ups*/


  ViewHolidayDetailslink(holidayId) {
    this.setState({
      holidayID: holidayId,
    });
    this.props.GetHolidayDetails(holidayId);
    this.Edittoggle();
  }
  LoadPastHolidays() {
    this.setState({
      PastHolidays: !this.state.PastHolidays
    });

  }

  handleChange(date) {
    this.setState({
        startDate: date
    });
}


  handleChange2(date) {
    this.setState({
        endDate: date
    });
}

/* Sorting  System */

onSort = (column) => (e) => {
  this.setState({IsDefaultSort: false});
  var SortData = this.state.sort.direction;
  var selected = SortData.filter(a => a.name == column);
  const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
  var data_from_state = this.props.getResponse.HolidayList;
  var notequals = 0;

 if(data_from_state != null){
  const sortedData = this.props.getResponse.HolidayList.sort((a, b) => {
      const nameA = (column == 'buildingNames') ? a[column].join(',').toLowerCase() : a[column].toLowerCase();
      const nameB = (column == 'buildingNames') ? b[column].join(',').toLowerCase() : b[column].toLowerCase();
      if (nameA < nameB) {
          notequals = 1;
          return -1;
      }
      if (nameA > nameB) {
          notequals = 1;
          return 1;
      }
      if (nameA == nameB) {
          return 0;
      }
      return 0;
  });

  if(selected[0].direction =='asc' && notequals == 1){
  sortedData.reverse();
}

SortData.map(x => (x.name !== column) ? x.onclick = false : x.onclick = true);
SortData.map(x => (x.name !== column) ? x.direction = SortData.filter(m => (m.name === x.name))[0].direction : x.direction = direction);

this.props.getResponse.HolidayList = sortedData;
  this.setState({
      sort: {
          column,
          direction:SortData,
      }
  });
 }
};

setArrow = (column) => {
  let className = 'workorder-sort-direction';
  let sortColumn = this.state.sort.direction.filter(x => (x.name === column))[0];
  className += (sortColumn.onclick === true) ? (sortColumn.direction === 'asc') ? ' asccolor' : ' desccolor' : ' desc';
  return className;
};

  render(getResponse, getLabels, UserPreference_response, UserCanEdit) {

    let Holidays = null,FilteredData = [], lUserCanEdit = true;
    let data = [],Error_Message;
    let label = this.props.getLabels;
    let PreferedDateFormat = this.props.UserPreference_response;
    let UserFormat = Conversions.UserPreferenceDateFormat_DatePicker(PreferedDateFormat);
    
    let OnPremiseState = (this.props.OnPremises !== undefined && this.props.OnPremises !== null) ? this.props.OnPremises : false;
    lUserCanEdit = this.props.UserCanEdit;
    lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit ? true : false;

    if (this.props.getResponse != undefined && this.props.getResponse.HolidayList != undefined && this.props.getResponse.HolidayList != null) {
      var numberOfRows = this.props.getResponse.HolidayList.length;
      if(this.state.IsDefaultSort){
        this.props.getResponse.HolidayList.sort((a,b)=>{
            let nameA = a['holidayName'].toLowerCase();
            let nameB = b['holidayName'].toLowerCase();
            if(nameA < nameB){
                return -1;
            }
            if(nameA > nameB){
                return 1;
            }
            if(nameA == nameB){
                return 0;
            }
            return 0;
        });
      }
      if(this.state.IsChangesSaved){
        this.props.getResponse.HolidayList.sort((a,b)=>{
          let nameA = (this.state.sort.column == 'buildingNames') ? a[this.state.sort.column].join(',').toLowerCase() : a[this.state.sort.column].toLowerCase();
          let nameB = (this.state.sort.column == 'buildingNames') ? b[this.state.sort.column].join(',').toLowerCase() : b[this.state.sort.column].toLowerCase();
          if(nameA < nameB){
              return -1;
          }
          if(nameA > nameB){
              return 1;
          }
          if(nameA == nameB){
              return 0;
          }
          return 0;
        });
        if(this.state.sort.direction.filter(x => x.name === this.state.sort.column)[0].direction === "desc"){
          this.props.getResponse.HolidayList.reverse();
        }
        this.setState({IsChangesSaved: false});
      }
      var l_date = new Date();
      if (numberOfRows) {
        if (!this.state.PastHolidays) {
          data = [];
        for (let i = 0; i < numberOfRows; i++) {  
                  var SpecialTo = new  Date(this.props.getResponse.HolidayList[i].holidayDate).setHours(0, 0, 0, 0);
                  l_date.setHours(0, 0, 0, 0); //discard the time

                  if (Number(SpecialTo) >= Number(l_date)) {
                     data.push(this.props.getResponse.HolidayList[i]);
                  }
                }
            }
        }

        var fromDate =  this.state.startDate;
        var toDate =  this.state.endDate;
 
        if(fromDate != null && toDate != null){
          
          fromDate = new Date(this.state.startDate);
          toDate = new Date(this.state.endDate);
  
          data.filter(function (e) {
              var aDate = new Date(e.holidayDate);
              if (aDate >= fromDate && aDate <= toDate) {
                  FilteredData.push(e);
              }
          });
          data = FilteredData;
        }

        if(data.length)
          FilteredData = data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
        if(FilteredData.length > 0){
        Holidays = FilteredData.map(el => (
          <tr key={el.holidayId}>
              <td width="5%"><input type="checkbox" id={el.holidayId} className="ZoneRows" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("ZoneRows", "main_Check_box"); }} /></td>
              {
                  ((Number(new Date (el.holidayDate).setHours(0, 0, 0, 0)) >= Number(l_date)) && lUserCanEdit) ? <td  width="30%" onClick={() => { this.ViewHolidayDetailslink(el.holidayId)}} style={{ color: '#6890C6','word-break':'break-all' }} className="link_cursor">{el.holidayName}</td> : 
                  <td  width="30%">{el.holidayName}</td>
              }
              <td width="40%" style={{'word-break':'break-all'}}><p max-height="20px;">{el.buildingNames.join(',')}</p></td>
              <td width="25%">{ Conversions.DateFormatBasedOnUserPreference(PreferedDateFormat,el.holidayDate) }</td>
              {/* <td>{new Date(el.holidayDate).toLocaleDateString()}</td> */}
          </tr>
      ));
    }
    else {
      Holidays = <tr> <td colSpan="4">No Records Found</td> </tr>
    }   
    }
    else {
      Holidays = <p>Loading Data</p>
    }

    // Error Message
    (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  Error: Select one or more Holiday to perform this action.</p> : Error_Message = " ";


    return (
     <div className="tenant_content_border">
      <div className="main_container">
        {Error_Message}
        <div className="buttons_container">
          <div className="holidays_btns">
          
          <Button id="btn_Holiday_DeleteHoliday" type="button" hidden={!lUserCanEdit} className="btn btn-black" onClick={this.DeleteHolidays}>{label['ManageTenants.Delete.Text'] !== undefined ? label['ManageTenants.Delete.Text'] : "Delete"}</Button>
          <Button id="btn_Holiday_CreateNewHoliday" type="button" hidden={!lUserCanEdit} className="btn btn-success" onClick={this.toggle} >{label['ManageHolidays.CreateHoliday.Text'] !== undefined ? label['ManageHolidays.CreateHoliday.Text'] : "Create New Holiday"} </Button>
          <input id="chk_Holiday_ShowPastHoliday" type="checkbox"  name="Show Past Holidays" checked={this.state.PastHolidays} onClick={this.LoadPastHolidays} style={{top:(this.props.OnPremises)? "3px":"1px", position:"relative"}} />{label['ManageHolidays.ShowPastHoliday.Text'] !== undefined ? label['ManageHolidays.ShowPastHoliday.Text'] : "Show Past Holidays"}
          
          </div>
          <div className="holidays_filter"  >
          <div className="holiday_searhinput">
          <SearchInput className="search-input " onChange={this.searchUpdated} />
          </div>

            <div className="holidays_date_filter_system">
              <div className={ OnPremiseState ? "date_range_filter OnPremiseHolidayDtFilter" : "date_range_filter HolidayDtFilter"} style={{ paddingRight: '205px' }}>
                <DatePicker className="Form_Datepicker date_filter"
                  customInput={<DatePickerCustom />}
                  selected={this.state.endDate} isClearable={true}
                  onChange={this.handleChange2} showDisabledMonthNavigation
                  dateFormat={UserFormat} />
              </div>
            <label className="float-left">{label['AfterHours.To.Text']}</label>
              
              <div className={ OnPremiseState ? "date_range_filter OnPremiseHolidayDtFilter HolidayDtPaddingOnpremise" : "date_range_filter HolidayDtFilter HolidayDtPadding"}>
                <DatePicker style={{ "width": "20px" }} className="Form_Datepicker date_filter"
                  customInput={<DatePickerCustom />}
                  selected={this.state.startDate} isClearable={true}
                  onChange={this.handleChange} placeholderText="Click to select a date"
                  dateFormat={UserFormat} />

              </div>
              <label className="float-left">{label['AfterHours.From.Text']}</label>

            </div>
           
          </div>       

        </div>

           <div className="table_container">
                    <Table id="table_Holidays" striped responsive className="Custom_table table_border">
                        <tbody className="cell_container tenant_cell">
                            <tr>
                                <th><input type="checkbox" className="main_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("ZoneRows", "main_Check_box"); }} /></th>
                                <th onClick={this.onSort('holidayName')} className="link_cursor">{label['ManageHolidays.Name.Text'] !== undefined ? label['ManageHolidays.Name.Text'] : "Name"} <span className={this.setArrow('holidayName')}></span></th>
                                <th onClick={this.onSort('buildingNames')} className="link_cursor">{label['ManageHolidays.Building.Text'] !== undefined ? label['ManageHolidays.Building.Text'] : "Buildings"} <span className={this.setArrow('buildingNames')}></span></th>
                                <th onClick={this.onSort('holidayDate')} className="link_cursor">{label['ManageHolidays.EffectiveDates.Text'] !== undefined ? label['ManageHolidays.EffectiveDates.Text'] : "Effective Dates"} <span className={this.setArrow('holidayDate')}></span></th>
                            </tr>

                            {Holidays}
                        </tbody>
                    </Table>
            </div>


        <Modal isOpen={this.state.modal} toggle={this.toggle} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
          <AddHolidayForm />
        </Modal>
        <Modal isOpen={this.state.Editmodal} toggle={this.Edittoggle} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
          <EditHolidayForm parentToChildData={[this.state.holidayID]} />
        </Modal>
        <Modal isOpen={this.state.Deletemodal} Deletemodal={this.Deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >
          <DeleteConfirmation parentToChildData={[(label['ManageHolidays.DeleteHeader.Text'] !== undefined ? label['ManageHolidays.DeleteHeader.Text'] : "Delete Holiday"),(label['ManageHolidays.DeleteHolidayMsg.Text'] !== undefined ? label['ManageHolidays.DeleteHolidayMsg.Text'] : "Are you sure you want to delete")]} Delete={this.Delete} />
        </Modal>
      </div>
    </div>
    );
  }

  searchUpdated(term) {
    this.setState({ searchTerm: term })
}

}

const mapStateToProps = state => {
  return {
    getResponse: state.HolidaysRootReducer,
    ModalOpenCloseResponse: state.ModalOpenCloseRootReducer,
    getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
    UserPreference_response: state.userPreferencesRootReducer.UserPreference,
    UserCanEdit: state.authService.HasApplicationFullAcess,
    OnPremises: state.authService.IsOnPremise
  };
};

const mapDispatchToProps = dispatch => {
  return {
    GetAllHolidays: () => dispatch(GetAllHolidays()),
    closeModalPopUp: (modaldata) => dispatch(closeModalPopUp(modaldata)),
    DeleteHoliday: (data) => dispatch(DeleteHoliday(data)),
    GetHolidayDetails: (id) => dispatch(GetHolidayDetails(id))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Holidays);





